import { IKnowledgeAreaLevel } from 'views/components/KnowledgeAreaLevel/knowledge-area-level.interface';

function convertAllLevelsByKnowledgeArea(
  allLevels: IKnowledgeAreaLevel[],
): IKnowledgeAreaLevel[] {
  return allLevels.sort((a, b) => a.orderNo - b.orderNo);
}

export { convertAllLevelsByKnowledgeArea };
